import { Link } from 'react-router-dom';
import styled, { css } from 'styled-components';
import { checkPixel, hexToRGB } from 'utils';

// commonCss
export const common = css`
  ${({ $display }) => $display && `display: ${$display}`};
  ${({ $position }) => $position && `position: ${$position}`};
  ${({ $left }) => $left && `left:${$left}`};
  ${({ $top }) => $top && `top:${$top}`};
  ${({ $bottom }) => $bottom && `bottom:${$bottom}`};
  ${({ $opacity }) => $opacity && `opacity : ${$opacity}`};
  ${({ $cursor }) => $cursor && `cursor: ${$cursor}`};
  ${({ $overflow }) => $overflow && `overflow: ${$overflow}`};
  ${({ $overflowX }) => $overflowX && `overflow-x: ${$overflowX}`};
  ${({ $overflowY }) => $overflowY && `overflow-y: ${$overflowY}`};
  ${({ $transition }) => $transition && `transition: ${$transition}`};
  ${({ $backgroundColor, theme }) =>
    $backgroundColor &&
    `background-color: ${hexToRGB(
      theme.colors[$backgroundColor] || $backgroundColor || theme.colors.primary,
      $backgroundColor.opacity || 1,
    )}`};
  @media ${({ theme }) => theme.device.tabelt} {
    ${({ $tDisplay }) => $tDisplay && `display: ${$tDisplay}`};
  }
  @media ${({ theme }) => theme.device.mobile} {
    ${({ $sDisplay }) => $sDisplay && `display: ${$sDisplay}`};
    ${({ $sLeft }) => $sLeft && `left:${$sLeft}`};
    ${({ $sTop }) => $sTop && `top:${$sTop}`};
  }
`;

// spaceCss
export const space = css`
  ${({ $margin }) => $margin && `margin: ${$margin}`};
  ${({ $marginBottom }) => $marginBottom && `margin-bottom: ${checkPixel($marginBottom)}`};
  ${({ $marginTop }) => $marginTop && `margin-top: ${checkPixel($marginTop)}`};
  ${({ $marginRight }) => $marginRight && `margin-right: ${checkPixel($marginRight)}`};
  ${({ $marginLeft }) => $marginLeft && `margin-left: ${checkPixel($marginLeft)}`};

  ${({ $padding }) => $padding && `padding: ${$padding}`};
  ${({ $paddingBottom }) => $paddingBottom && `padding-bottom: ${checkPixel($paddingBottom)}`};
  ${({ $paddingTop }) => $paddingTop && `padding-top: ${checkPixel($paddingTop)}`};
  ${({ $paddingRight }) => $paddingRight && `padding-right: ${checkPixel($paddingRight)}`};
  ${({ $paddingLeft }) => $paddingLeft && `padding-left: ${checkPixel($paddingLeft)}`};

  ${({ $positionTop }) => $positionTop && `top: ${checkPixel($positionTop)}`};
  ${({ $positionLeft }) => $positionLeft && `left : ${checkPixel($positionLeft)}`};
  ${({ $positionRight }) => $positionRight && `right : ${checkPixel($positionRight)}`};
  ${({ $positionBottom }) => $positionBottom && `bottom : ${checkPixel($positionBottom)}`};
  ${({ $transform }) => $transform && `transform : ${$transform}`};
  ${({ $zIndex }) => $zIndex && `z-index: ${$zIndex}`};
  @media ${({ theme }) => theme.device.tabelt} {
  }
  @media ${({ theme }) => theme.device.mobile} {
    ${({ $sPadding }) => $sPadding && `padding: ${$sPadding}`};
    ${({ $sMarginTop }) => $sMarginTop && `margin-top: ${checkPixel($sMarginTop)}`};
  }
`;

// elSize
export const elSize = css`
  ${({ $width }) => $width && `width : ${checkPixel($width)}`};
  ${({ $minWidth }) => $minWidth && `min-width : ${checkPixel($minWidth)}`};
  ${({ $maxWidth }) => $maxWidth && `max-width: ${checkPixel($maxWidth)}`};
  ${({ $height }) => $height && `height:${checkPixel($height)}`};
  ${({ $minHeight }) => $minHeight && `min-height: ${checkPixel($minHeight)}`};
  ${({ $maxHeight }) => $maxHeight && `max-height: ${checkPixel($maxHeight)}`};
  @media ${({ theme }) => theme.device.tabelt} {
  }
  @media ${({ theme }) => theme.device.mobile} {
    ${({ $sWidth }) => $sWidth && `width : ${checkPixel($sWidth)}`};
    ${({ $sHeight }) => $sHeight && `height:${checkPixel($sHeight)}`};
  }
`;

// flexCss
export const flexCss = css`
  ${({ $flex }) => $flex && `flex:${$flex}`};
  ${({ $flexDirection }) => $flexDirection && `flex-direction: ${$flexDirection}`};
  ${({ $justifyContent }) => $justifyContent && `justify-content: ${$justifyContent}`};
  ${({ $alignItems }) => $alignItems && `align-items: ${$alignItems}`};
  ${({ $gap }) => $gap && `gap : ${checkPixel($gap)}`};
  @media ${({ theme }) => theme.device.tabelt} {
    ${({ $tGap }) => $tGap && `gap : ${checkPixel($tGap)}`};
    ${({ $tFlexDirection }) => $tFlexDirection && `flex-direction: ${$tFlexDirection}`};
  }
  @media ${({ theme }) => theme.device.mobile} {
    ${({ $sGap }) => $sGap && `gap : ${checkPixel($sGap)}`};
    ${({ $sFlexDirection }) => $sFlexDirection && `flex-direction: ${$sFlexDirection}`};
  }
`;

// p tag css
export const TextCss = css`
  ${({ $fontSize }) => $fontSize && `font-size: ${$fontSize}px`};
  color: ${({ $color, theme }) => ($color && `${theme.colors[$color]}`) || `${theme.colors.black}`};
  ${({ $fontWeight }) => $fontWeight && `font-weight: ${$fontWeight}`};
  ${({ $textAlign }) => $textAlign && `text-align:${$textAlign}`};
  ${({ $lineHeight }) => $lineHeight && `line-height:${$lineHeight}`};
  ${({ $letterSpacing }) => $letterSpacing && `letter-spacing: ${$letterSpacing}`};

  @media ${({ theme }) => theme.device.tabelt} {
    ${({ $mFontSize }) => $mFontSize && `font-size: ${$mFontSize}px`};
  }
  @media ${({ theme }) => theme.device.mobile} {
    ${({ $sFontSize }) => $sFontSize && `font-size: ${$sFontSize}px`};
    ${({ $sLetterSpacing }) => $sLetterSpacing && `letter-spacing: ${$sLetterSpacing}`};
  }
`;

// button css

export const settingCss = css`
  ${common};
  ${space};
  ${elSize};
  ${flexCss};
`;

export const LinkStyle = styled(Link)`
  ${settingCss};
`;

export const DivStyle = styled.div`
  ${settingCss};
`;

export const UlStyle = styled.ul`
  ${settingCss};
`;

export const LiStyle = styled.li`
  ${settingCss};
`;

// text style setting
export const TextStyle = styled.p`
  ${settingCss};
  ${TextCss};
`;

export const SpanStyle = styled.span`
  ${settingCss};
  ${TextCss};
`;

export const IconStyle = styled.span`
  ${common};
  ${elSize};
  ${space};
  display: inline-block;
  & > svg {
    width: 100%;
    height: 100%;
    ${({ theme, $fill }) => $fill && `fill: ${hexToRGB(theme.colors[$fill], 1)};`};
  }
  & > svg > path {
    ${({ theme, $pathFill }) => $pathFill && `fill:${hexToRGB(theme.colors[$pathFill] || $pathFill, 1)}`};
    ${({ theme, $pathStroke }) => $pathStroke && `stroke: ${hexToRGB(theme.colors[$pathStroke] || $pathStroke, 1)}`};
  }
`;
